import React, { Component } from 'react'
import styled from 'styled-components'

/* eslint-disable */

import IconArrowDown from '../../assets/icons/arrow-down.svg'

const ElementSelectorStyle = styled.div`
  .elementSelectorContainer {
    display: flex;

    select {
      outline: none;
      font-weight: 600;
      letter-spacing: 1px;
      font-size: 1.5625em;
      border: none;
      background: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 0;
      text-overflow: '';
      padding: 0;
      cursor: pointer;
    }
  
    #width_tmp_select {
      color: transparent;
      position: absolute;
      pointer-events: none;
    }
  
    img {
      height: 32px;
    }
  }

  h5 {
    color: #A0A0A0;
    // margin-top: 4px;
  }
`;

export default class ElementSelector extends Component {
  componentDidMount = () => {
    let indexTMP = parseInt(this.props.elementDisplayedState, 10) - 1;
    if (indexTMP >= 3) {
      document.querySelector('#categoryDropDown').selectedIndex = `${indexTMP + 1}`;
    } else {
      document.querySelector('#categoryDropDown').selectedIndex = `${indexTMP}`;
    }
    
    document.querySelector('#width_tmp_option').innerHTML = document.querySelector('#categoryDropDown option:checked').innerText;

    document.querySelector('#categoryDropDown').style.width = document.querySelector('#width_tmp_select').clientWidth + 'px';

    document.querySelector('#categoryDropDown').addEventListener('change', function() {
      document.querySelector('#width_tmp_option').innerHTML = document.querySelector('#categoryDropDown option:checked').innerText;

      this.style.width = document.querySelector('#width_tmp_select').clientWidth + 'px';
    })
  }
  
  render() {
    const { changeState, data, elementDisplayedState } = this.props;
    function elements1(value){
      return value.node.frontmatter.element === 1
    }
    function elements2(value){
      return value.node.frontmatter.element === 2 && value.node.frontmatter.dateCountDown <= 0
    }
    function elements3(value){
      return value.node.frontmatter.element === 3
    }
    function elements4(value){
      return value.node.frontmatter.element === 4
    }
    function elements5(value){
      return value.node.frontmatter.element === 5
    }
    return (
      <ElementSelectorStyle>
        <div className="elementSelectorContainer">
          <select name="" id="categoryDropDown" onChange={changeState}>
            <option value="1">Punti di interesse</option>
            <option value="2">Eventi</option>
            <option value="3" disabled>Agriturismi & Co.</option>
            <option disabled>──────────</option>
            <option value="4">Chi siamo</option>
            <option value="5">Il paese</option>
          </select>

          <select id="width_tmp_select">
            <option id="width_tmp_option"></option>
          </select>
          
          <img src={IconArrowDown} alt="Icon Dropdown" />
        </div>

        {elementDisplayedState == 1 && data.allMarkdownRemark.edges.filter(elements1).length === 1 &&
            <h5>{data.allMarkdownRemark.edges.filter(elements1).length} punto di interesse</h5>
        }
        {elementDisplayedState == 1 && data.allMarkdownRemark.edges.filter(elements1).length !== 1 &&
            <h5>{data.allMarkdownRemark.edges.filter(elements1).length} punti di interesse</h5>
        }
        {elementDisplayedState == 2 && data.allMarkdownRemark.edges.filter(elements2).length === 1 &&
            <h5>{data.allMarkdownRemark.edges.filter(elements2).length} evento futuro</h5>
        }
        {elementDisplayedState == 2 && data.allMarkdownRemark.edges.filter(elements2).length !== 1 &&
            <h5>{data.allMarkdownRemark.edges.filter(elements2).length} eventi futuri</h5>
        }
        {elementDisplayedState == 3 &&
            <h5>{data.allMarkdownRemark.edges.filter(elements3).length} cibo e altro</h5>
        }
        {elementDisplayedState == 4 &&
            <h5>Proloco di Ozzero</h5>
        }
        {elementDisplayedState == 5 &&
            <h5>La storia</h5>
        }
      </ElementSelectorStyle>
    )
  }
}
